<template>
  <div
    tabindex="0"
    :class="[
      'overflow-y-auto overflow-x-hidden fixed top-2 sm:top-28 right-0 left-0 m-auto w-full md:inset-0 h-modal md:h-full justify-center items-center flex z-[6]',
      isShowModal ? 'block' : 'hidden',
    ]"
    @click="closeModal"
  >
    <div class="relative p-4 w-full h-full max-w-3xl">
      <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
        <div
          class="p-4 rounded-t flex justify-between items-center border-b border-gray-200 dark:border-gray-600"
        >
          <div>
            <h3 class="capitalize text-xl !text-[#dc3545] font-[Inter]" v-text="campaignDetails.title"></h3>
          </div>
          <button
            aria-label="close"
            type="button"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white close"
            @click="closeModal"
          >
            <svg
              class="w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </button>
        </div>

        <div class="p-6 space-y-6">
          <!-- <div>
            <img
              src="/assets/img/img-sale.png"
              alt=""
              width="100%"
              class="h-52 rounded aspect-video"
            />
          </div> -->
          <div class="text-lg"> <!-- Removed mb-4, parent space-y-6 or children margins will handle spacing -->
            <div>
              <!-- Discount Codes Section -->
              <div class="flex flex-col gap-4 items-center justify-center mb-6"> <!-- Adjusted gap and mb -->
                <div v-for="discount in campaignDetails.discounts" :key="discount.code"
                     class="flex w-full max-w-sm sm:max-w-md"> {/* Control width and centering */}
                  <input
                    type="text"
                    class="flex-grow px-3 py-2.5 text-sm bg-gray-50 dark:bg-gray-800 border border-r-0 border-green-400 rounded-l-md focus:ring-green-500 focus:border-green-500 dark:border-gray-600 dark:focus:ring-green-600 dark:focus:border-green-600"
                    :value="discount.code"
                    readonly
                  />
                  <button
                    @click="copyText(discount.code)"
                    class="inline-flex items-center px-4 py-2.5 text-sm font-medium text-white bg-green-500 rounded-r-md hover:bg-green-600 focus:ring-4 focus:outline-none focus:ring-green-300 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800 transition-colors duration-150"
                  >
                    {{ discount.copyButtonText }}
                  </button>
                </div>
              </div>
              <!-- Discount Descriptions Section -->
              <div class="space-y-3 text-gray-700 dark:text-gray-300">
                <p v-for="discount in campaignDetails.discounts" :key="discount.code + '-desc'" v-html="discount.descriptionHtml" class="leading-relaxed"></p>
                <strong v-if="campaignDetails.validityPeriod" class="block mt-2 text-gray-800 dark:text-gray-200">
                  Tất cả mã giảm giá áp dụng từ ngày {{ campaignDetails.validityPeriod }}
                </strong>
              </div>
            </div>
          </div>
          <!-- Thank You Message -->
          <div class="text-center text-gray-600 dark:text-gray-400">
            <p v-html="campaignDetails.thankYouMessageHtml"></p>
          </div>
        </div>
        <div
          class="p-6 rounded-b border-gray-200 border-t dark:border-gray-600"
        >
          <div class="flex flex-col gap-3">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { useToast } from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

const $toast = useToast()
// The $toast.clear() call here will clear any existing toasts from anywhere
// in the application as soon as this component is set up.
// This might be intended, but be cautious if other components show persistent toasts.
$toast.clear()

const props = defineProps({
  exits_notification: {
    type: Boolean,
    default: true, // Assuming it should be visible by default if the prop is not provided
  },
})

const isShowModal = ref(props.exits_notification)

const campaignDetails = ref({
  title: 'Thông Báo : Sale Tưng Bừng Tháng 12',
  validityPeriod: '21/12/2024 - 28/12/2024',
  discounts: [
    {
      code: 'GIAMGIA5KTHANG12',
      copyButtonText: 'Copy mã 1',
      descriptionHtml: 'Nhập mã 1 <strong>giảm 5k</strong> cho đơn hàng trên 50k',
    },
    {
      code: 'GIAMGIA10KTHANG12',
      copyButtonText: 'Copy mã 2',
      descriptionHtml: 'Nhập mã 2 <strong>giảm 10k</strong> cho đơn hàng trên 150k',
    },
    {
      code: 'GIAMGIA20KTHANG12',
      copyButtonText: 'Copy mã đặt biệt',
      descriptionHtml: 'Nhập mã đặc biệt <strong>giảm 20k</strong> cho đơn hàng trên 300k',
    },
  ],
  thankYouMessageHtml: `<span style="font-size: 18px"><em>Cảm ơn bạn vì đã chọn chúng tôi. Hy vọng bạn sẽ có trải nghiệm tuyệt vời khi sử dụng sản phẩm dịch vụ của chúng tôi. Rất mong sẽ tiếp tục nhận được sự ủng hộ của bạn trong thời gian tới</em></span>`,
})

function closeModal(event) {
  if (event.target === event.currentTarget || event.target.closest('.close')) {
    isShowModal.value = false
  }
}

const copyText = async (textToCopy) => {
  try {
    await navigator.clipboard.writeText(textToCopy)
    $toast.success('Đã sao chép văn bản vào bảng nhớ tạm')
  } catch (err) {
    console.error('Failed to copy text: ', err)
    $toast.error('Không thể sao chép. Vui lòng thử lại.')
  }
}
</script>
